export const pageMapping: any = {
  "/lead-pool": 41,
  "/company": 11,
  "/my-leads": 19,
  "/my-team-lead": 54,
  "/dashboard": 1,
  "/Duplicatelead": 125,
  "/created-lead": 210,
  "/my-team-created-lead": 222,
  "/projects": 224,
  "/project": 224,
  "/project-details": 224,
  "/my-project": 224,
  "/allocated-project": 224,
  "/allocated-project-details": 224,
};